import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Text } from '@fragments';
import StudioAi from '../StudioAi';
import './styles.scss';

// `thinking` shows the AI orb, animated, on the latest assistant message while a
// run works. `orb` shows it at rest instead, and `orbId` lets it travel between
// messages as one shared element. `trailing` closes the text's last line (citation
// chips); `leading` comes before the text (the images sent with it), `children` follow it
// inside the bubble; `actions` sit beside it.
// Line breaks are kept: an answer (contract 1.7.0) may come in short paragraphs or "- " lists.
// Memoized: a settled message renders again only when its own props change.
function ChatMessage({ message: m, thinking = false, orb = thinking, orbId, actions, leading, trailing, children }) {
  const mark = <StudioAi size={26} active={thinking} />;
  return <motion.div initial={{ opacity: 0, y: 5 }} animate={{ opacity: 1, y: 0 }} className={`studio-message studio-message--${m.role}`}>
    {orb && (orbId ? <motion.span layoutId={orbId} className="studio-message__orb">{mark}</motion.span> : mark)}
    {actions && <span className="studio-message__actions">{actions}</span>}
    <div>{leading}{m.text && <Text.p contrast={9} style={{ whiteSpace: 'pre-line' }}>{m.text}{trailing && <> {trailing}</>}</Text.p>}{children}</div>
  </motion.div>;
}

export default memo(ChatMessage);
